'use strict';

/*global services*/
/*global K2Modal*/
/*global isEmpty*/
/*exported K2Confirm */
function K2Confirm(id) {
  K2Modal.call(this, id);

  this.init();
}

K2Confirm.prototype = $.extend({}, K2Modal.prototype, {
  constructor: 'K2Confirm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.registerCommonCallbacks();

    var confirmHandler = function () {
      if (!isEmpty(_this.setting.confirmCallBack)) {
        if ($.isFunction(_this.setting.confirmCallBack)) {
          _this.setting.confirmCallBack();
        } else {
          window[_this.setting.confirmCallBack]();
        }
      }

      return false;
    };

    var rejectHandler = function () {
      if (!isEmpty(_this.setting.rejectCallBack)) {
        if ($.isFunction(_this.setting.rejectCallBack)) {
          _this.setting.rejectCallBack();
        } else {
          window[_this.setting.rejectCallBack]();
        }
      } else {
        _this.close();
      }

      return false;
    };

    var cancelHandler = function () {
      if (!isEmpty(_this.setting.cancelCallBack)) {
        if ($.isFunction(_this.setting.cancelCallBack)) {
          _this.setting.cancelCallBack();
        } else {
          window[_this.setting.cancelCallBack]();
        }
      } else {
        _this.close();
      }

      return false;
    };

    _this.$modal.find('.modal-footer .submit.btn-primary').bind('click', confirmHandler);
    _this.$modal.find('.modal-footer .submit.btn-danger').bind('click', rejectHandler);
    _this.$modal.find('.modal-footer .submit.btn-default').bind('click', cancelHandler);
  },

  setModalForm: function setModalForm() {
    var _this = this;

    _this.$modal.find('.modal-footer .submit.btn-primary').html(_this.setting.confirmBtnTitle);
    _this.$modal.find('.modal-footer .submit.btn-danger').html(_this.setting.rejectBtnTitle);
    _this.$modal.find('.modal-button__cancel').html(_this.setting.cancelBtnTitle);

    _this.$modal.find('.modal-footer .modal-buttons').hide();
    _this.$modal.find('.modal-footer .modal-buttons-' + _this.setting.buttonsSize).show();

    _this.$modal.find('.modal-button__reject').hide();
    if (_this.setting.viewRejectBtn) {
      _this.$modal.find('.modal-button__reject').show();
    }

    _this.$modal.find('.modal-button__cancel').hide();
    if (_this.setting.viewCancelBtn) {
      _this.$modal.find('.modal-button__cancel').show();
    }

    if (_this.setting.buttonsSize === 'lg') {
      if (_this.setting.viewCancelBtn) {
        _this.$modal.find('.modal-buttons-cancel').show();
        _this.$modal.find('.modal-buttons-no-cancel').hide();
      } else {
        _this.$modal.find('.modal-buttons-cancel').hide();
        _this.$modal.find('.modal-buttons-no-cancel').show();
      }
    }

    _this.$modal.find('.modal-button__cancel--header').hide();
    if (_this.setting.viewCancelHeaderBtn) {
      _this.$modal.find('.modal-button__cancel--header').show();
    }
  },

  defineK2ConfirmSetting: function defineK2ModalSetting() {
    var _this = this;

    _this.defineK2ModalSetting();

    _this.defaultSetting = $.extend({}, _this.defaultSetting, {
      title: services.get('translator').trans('modal.title'),
      confirmBtnTitle: services.get('translator').trans('form.confirm'),
      rejectBtnTitle: services.get('translator').trans('form.reject'),
      cancelBtnTitle: services.get('translator').trans('form.cancel'),
      buttonsSize: 'auto',
      keyboardClose: false,
      width: 'sm',
      height: 'auto',
      confirmCallBack: null,
      rejectCallBack: null,
      cancelCallBack: null,
      viewRejectBtn: true,
      viewCancelBtn: false,
      viewCancelHeaderBtn: false
    });

  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.defineK2ConfirmSetting();

    var modalStr = '';
    modalStr += '<div class="modal fade ' + _this.defaultSetting.modalClass + '" tabindex="-1" role="dialog" id="' + _this.id + '" data-modal_class="' + _this.defaultSetting.modalClass + '">';
    modalStr +=   '<div class="modal-dialog" role="document">';
    modalStr +=     '<div class="modal-content">';
    modalStr +=       '<div class="modal-header">';
    modalStr +=         '<button type="button" class="close modal-button__cancel--header" data-dismiss="modal" aria-label="' + _this.defaultSetting.closeBtnTitle + '"><span aria-hidden="true">&times;</span></button>';
    modalStr +=         '<h4 class="modal-title">' + _this.defaultSetting.title + '</h4>';
    modalStr +=       '</div>';
    modalStr +=       '<div class="modal-body">' + _this.defaultSetting.content + '</div>';
    modalStr +=       '<div class="modal-footer">';
    modalStr +=         '<div class="row modal-buttons modal-buttons-lg modal-buttons-no-cancel">';
    modalStr +=           '<div class="col-xs-6">';
    modalStr +=             '<button type="button" class="btn btn-danger submit full-width modal-button__reject">' + _this.defaultSetting.rejectBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=           '<div class="col-xs-6">';
    modalStr +=             '<button type="button" class="btn btn-primary submit full-width modal-button__confirm">' + _this.defaultSetting.confirmBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=         '</div>';
    modalStr +=         '<div class="row modal-buttons modal-buttons-lg modal-buttons-cancel">';
    modalStr +=           '<div class="col-xs-4">';
    modalStr +=             '<button type="button" class="btn btn-danger submit full-width modal-button__reject">' + _this.defaultSetting.rejectBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=           '<div class="col-xs-4">';
    modalStr +=             '<button type="button" class="btn btn-primary submit full-width modal-button__confirm">' + _this.defaultSetting.confirmBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=           '<div class="col-xs-4">';
    modalStr +=             '<button type="button" class="btn btn-default submit full-width modal-button__cancel">' + _this.defaultSetting.cancelBtnTitle + '</button>';
    modalStr +=           '</div>';
    modalStr +=         '</div>';
    modalStr +=         '<div class="modal-buttons modal-buttons-auto">';
    modalStr +=           '<button type="button" class="btn btn-danger submit modal-button__reject">' + _this.defaultSetting.rejectBtnTitle + '</button>';
    modalStr +=           '<button type="button" class="btn btn-primary submit modal-button__confirm">' + _this.defaultSetting.confirmBtnTitle + '</button>';
    modalStr +=           '<button type="button" class="btn btn-default submit modal-button__cancel">' + _this.defaultSetting.cancelBtnTitle + '</button>';
    modalStr +=         '</div>';
    modalStr +=       '</div>';
    modalStr +=     '</div>';
    modalStr +=   '</div>';
    modalStr += '</div>';

    _this.$modal = $(modalStr);

    $('body').append(_this.$modal);

    _this.registerCallbacks();
  }
});
